import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap'
import NavbarComp from '../components/NavbarComp'
import FooterComp from '../components/FooterComp'
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
  return {

  }
}


const mapDispatchToProps = dispatch => ({

});

class BenefitsToYou extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render() {
    return <Fragment>

      <NavbarComp/>
      <div className="page-sections">
        <div className='terms-and-conditions-wrap'>
          <Container>
            <div className='terms-and-conditions-contents'>
              <h2 className='main-title-style'>Benefits to you</h2>
              <p>Thank you for using the MyAlertness app and we hope you gain some benefits from doing so.</p>
              <p>It has been well reported in scientific literature that as humans we tend to be very bad at understanding our performance decline as a result of low alertness. We also know that our decision making becomes impaired when alertness level low. It takes us longer to process information and we can take more risky decisions.</p>
              <p>We therefore wanted to give individuals a chance to get an objective overview of how their alertness is at the beginning of a shift and how it compares to your baseline. If you can understand that you may be at risk of low alertness on that shift then we hope you will bear that in mind, make allowances and take precautions that keep you and others around you safe.</p>
              <p>The consequences of low alertness can be catastrophic. The worst case scenario does not bear thinking about. What if you caused an accident and you survived but one or many others did not. What about the consequences for your family, for their family. I won’t go on.</p>
              <p>As well as seeing your daily alertness you can see your past scores. You can access this from the dashboard. We hope you can identify trends in days and shifts when you might be at risk of low alertness. Is it because you do something in the evening once a week, perhaps there was a period of warm weather at night, was it your first or second night shift. We want you to be able to identify trends and make amendments the day / night before as well as increase understanding of the potential effects the next day so you can take precautions.</p>
              <p>Finally, you all have the opportunity to undertake a shortened version of our sleep health self-assessment. It should take about 5 minutes to complete and you will be able to immediately download a personalised report of your results with lots of hints and tips with up to 10 factsheets you can download to understand how certain lifestyle factors can influence your sleep and in turn your alertness. We have run this for over 10,000 participants and we know from working with organisations on multiple rounds, those who participated twice improved sleep duration, sleep quality, daytime sleepiness and lifestyle factors.</p>
              <p>If we are all more aware of our alertness and can improve it over the long term, we all benefit. Feel free to contact us if you have any questions or would like to share how you have found the app useful.</p>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp/>

    </Fragment>
  }
}

BenefitsToYou.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(BenefitsToYou);
